import { RasterComponentOption } from "../components/raster_component"

const crops = [
  'Wheat',
  'Rice',
  'Maize',
  'Barley',
  'Small Millet',
  'Pearl Millet',
  'Sorghum',
  'Other Cereals',
  'Potato',
  'Sweet Potato',
  'Yams',
  'Cassava',
  'Other Roots',
  'Bean',
  'Chickpea',
  'Cowpea',
  'Pigeon Pea',
  'Lentil',
  'Other Pulses',
  'Soybean',
  'Groundnut',
  'Coconut',
  'Oilpalm',
  'Sunflower',
  'Rapeseed',
  'Sesame Seed',
  'Other Oil Crops',
  'Sugarcane',
  'Sugarbeet',
  'Cotton',
  'Other Fibre Crops',
  'Arabic Coffee',
  'Robust Coffee',
  'Cocoa',
  'Tea',
  'Tobacco',
  'Banana',
  'Plantain',
  'Citrus',
  'Other Tropical Fruit',
  'Temperate Fruit',
  'Tomato',
  'Onion',
  'Other Vegetables',
  'Rubber',
  'Rest Of Crops'
]
const crop_code = [
  'WHEA',
  'RICE',
  'MAIZ',
  'BARL',
  'MILL',
  'PMIL',
  'SORG',
  'OCER',
  'POTA',
  'SWPO',
  'YAMS',
  'CASS',
  'ORTS',
  'BEAN',
  'CHIC',
  'COWP',
  'PIGE',
  'LENT',
  'OPUL',
  'SOYB',
  'GROU',
  'CNUT',
  'OILP',
  'SUNF',
  'RAPE',
  'SESA',
  'OOIL',
  'SUGC',
  'SUGB',
  'COTT',
  'OFIB',
  'COFF',
  'RCOF',
  'COCO',
  'TEAS',
  'TOBA',
  'BANA',
  'PLNT',
  'CITR',
  'TROF',
  'TEMF',
  'TOMA',
  'ONIO',
  'VEGE',
  'RUBB',
  'REST'
]


const data_point = ['Yield', 'Production', 'Harvested Area', 'Physical Area']
const data_point_code = ['Y', 'P', 'H', 'A']
const data_point_unit = ['t', 't', 'ha', 'ha']
const data_point_area = ['ha', '100km²', '100km²', '100km²']

const tech = ['Irrigated', 'Rainfed', 'All']
const tech_code = ['I', 'R', 'A']


const options: RasterComponentOption[] = []

for (let i = 0; i < crops.length; i++) {
    for (let j = 0; j < data_point.length; j++) {
        for (let k = 0; k < tech.length; k++) {
            options.push({ name: `${tech[k]} ${crops[i]} ${data_point[j]} 2020 [[${data_point_unit[j]}${data_point[j] === 'Yield' ? '/' : '-'}${data_point_area[j]}]]`, 
              source: `ind:spam2020_V2r0_global_${data_point_code[j]}_${crop_code[i]}_${tech_code[k]}`, 
              unit: data_point_unit[j], 
              area: data_point_area[j], 
              option: [crops[i], data_point[j], tech[k], '2020'] })
        }
    }
}

const crops_2010 = [
  'Wheat',
  'Rice',
  'Maize',
  'Barley',
  'Pearl Millet',
  'Small Millet',
  'Sorghum',
  'Other Cereals',
  'Potato',
  'Sweet Potato',
  'Yams',
  'Cassava',
  'Other Roots',
  'Bean',
  'Chickpea',
  'Cowpea',
  'Pigeonpea',
  'Lentil',
  'Other Pulses',
  'Soybean',
  'Groundnut',
  'Coconut',
  'Oilpalm',
  'Sunflower',
  'Rapeseed',
  'Sesameseed',
  'Other Oil Crops',
  'Sugarcane',
  'Sugarbeet',
  'Cotton',
  'Other Fibre Crops',
  'Arabica Coffee',
  'Robusta Coffee',
  'Cocoa',
  'Tea',
  'Tobacco',
  'Banana',
  'Plantain',
  'Tropical Fruit',
  'Temperate Fruit',
  'Vegetables',
  'Rest Of Crops'
]
const crop_code_2010 = [
  'WHEA',
  'RICE',
  'MAIZ',
  'BARL',
  'PMIL',
  'SMIL',
  'SORG',
  'OCER',
  'POTA',
  'SWPO',
  'YAMS',
  'CASS',
  'ORTS',
  'BEAN',
  'CHIC',
  'COWP',
  'PIGE',
  'LENT',
  'OPUL',
  'SOYB',
  'GROU',
  'CNUT',
  'OILP',
  'SUNF',
  'RAPE',
  'SESA',
  'OOIL',
  'SUGC',
  'SUGB',
  'COTT',
  'OFIB',
  'ACOF',
  'RCOF',
  'COCO',
  'TEAS',
  'TOBA',
  'BANA',
  'PLNT',
  'TROF',
  'TEMF',
  'VEGE',
  'REST'
]

for (let i = 0; i < crops.length; i++) {
    for (let j = 0; j < data_point.length; j++) {
        for (let k = 0; k < tech.length; k++) {
            options.push({ name: `${tech[k]} ${crops_2010[i]} ${data_point[j]} 2010 [[${data_point_unit[j]}${data_point[j] === 'Yield' ? '/' : '-'}${data_point_area[j]}]]`, 
              source: `ind:spam2010V2r0_global_${data_point_code[j]}_${crop_code_2010[i]}_${tech_code[k]}`, 
              unit: data_point_unit[j], 
              area: data_point_area[j], 
              option: [crops_2010[i], data_point[j], tech[k], '2010'],
              transform: data_point_code[j] === 'Y' ? (val: number) => val / 1000 : undefined
            })
        }
    }
}

const crops_2000 = [
  'Wheat',
  'Rice',
  'Maize',
  'Barley',
  'Millet',
  'Sorghum',
  'Potato',
  'Sweet Potato and Yams',
  'Cassava',
  'Bananas and Plantains',
  'Soybean',
  'Bean',
  'Other Pulses',
  'Sugarcane',
  'Sugarbeet',
  'Coffee',
  'Cotton',
  'Other Fibre Crops',
  'Groundnuts',
  'Other Oil Crops',
  'Other Crops'
]
const crop_code_2000 = [
  'WHEA',
  'RICE',
  'MAIZ',
  'BARL',
  'MILL',
  'SORG',
  'POTA',
  'SWPY',
  'CASS',
  'BANP',
  'SOYB',
  'BEAN',
  'OPUL',
  'SUGC',
  'SUGB',
  'COFF',
  'COTT',
  'OFIB',
  'GROU',
  'OOIL',
  'OTHE'
]

const data_point_code_2000 = ['Y', 'R', 'H', 'P']

for (let i = 0; i < crops_2000.length; i++) {
    for (let j = 0; j < data_point.length; j++) {
        for (let k = 0; k < tech.length; k++) {
            options.push({ name: `${tech[k]} ${crops_2000[i]} ${data_point[j]} 2000 [[${data_point_unit[j]}${data_point[j] === 'Yield' ? '/' : '-'}${data_point_area[j]}]]`, 
              source: `ind_team:spam2000V3r107_global_${data_point_code_2000[j]}_${crop_code_2000[i]}_${tech_code[k]}`, 
              unit: data_point_unit[j], 
              area: data_point_area[j], 
              option: [crops_2000[i], data_point[j], tech[k], '2000'],
              transform: data_point_code_2000[j] === 'Y' ? (val: number) => val / 1000 : undefined
            })
        }
    }
}


export const SPAMProperties: RasterComponentOption[] = options